const activeSessionKey = "competenceo-current-session-v1";

function hasActiveSession() {
  try {
    return Boolean(localStorage.getItem(activeSessionKey));
  } catch {
    return false;
  }
}

function deletionNeedsClosure(target: EventTarget | null) {
  if (!(target instanceof Element)) return false;
  return Boolean(target.closest(".delete-activity, .delete-history-session"));
}

document.addEventListener("click", (event) => {
  if (!deletionNeedsClosure(event.target) || !hasActiveSession()) return;
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
  window.alert("Veuillez d’abord clôturer la séance avant de supprimer.");
}, true);
